/** @format */

import template from './gb-item-type.html';

export const GbItemTypeComponent = {
    template,
    bindings: {
        item: '<',
    },
    controller: class GbItemTypeComponent {
        constructor($translate) {
            'ngInject';

            this.$translate = $translate;

            this.itemTypeText = {
                bidding: this.$translate.instant('ITEM_TYPE_SILENT_AUCTION'),
                live: this.$translate.instant('ITEM_TYPE_LIVE_AUCTION'),
                sealed: this.$translate.instant('ITEM_TYPE_SEALED_AUCTION'),
                donation: this.$translate.instant('ITEM_TYPE_DONATION'),
                raffle: this.$translate.instant('ITEM_TYPE_RAFFLE'),
                purchase: this.$translate.instant('ITEM_TYPE_PURCHASE'),
            };
        }

        getItemTypeText() {
            let itemType = this.item && this.item.item_type;

            if (!itemType) {
                return;
            } else if (itemType === 'bidding') {
                let concreteItem = this.item.getConcreteItemFromCache();

                if (!concreteItem) {
                    return;
                } else if (concreteItem.live_auction_item) {
                    return this.itemTypeText.live;
                } else if (concreteItem.sealed_bid_item) {
                    return this.itemTypeText.sealed;
                }
            }

            return this.itemTypeText[itemType];
        }
    },
};
